import { HttpInterceptorFn } from '@angular/common/http';
import { ToastService } from '../services/toast.service';
import { inject } from '@angular/core';
import { catchError, EMPTY } from 'rxjs';
import { TransactionStore } from '../../store/transaction.store';
import { PriceStore } from '../../store/price.store';
import { Router } from '@angular/router';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toastService = inject(ToastService);
  const transactionStore = inject(TransactionStore);
  const priceStore = inject(PriceStore);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error) => {
      console.error(error);
      toastService.emitToast({
        isSuccess: false,
        message: error?.error?.message || 'Something went wrong'
      });

      const storeResetMap: { [key: string]: () => void } = {
        transaction: () => transactionStore.resetLoadingStates(true),
        price: () => priceStore.resetLoadingStates(true)
      };
      let hasMatch = false;

      Object.keys(storeResetMap).forEach((key) => {
        if (req.url.includes(key)) {
          storeResetMap[key]();
          hasMatch = true;
        }
      });

      // special handling for getRoles and getUserFactories endpoints. refactor as needed.
      if (!hasMatch) {
        router.navigate(['/no-records']);
      }

      // returns empty to allow API re-call in stores
      return EMPTY;
    })
  );
};
